import { render, staticRenderFns } from "./ViewUserModal.vue?vue&type=template&id=1445883a&scoped=true&"
import script from "./ViewUserModal.vue?vue&type=script&lang=js&"
export * from "./ViewUserModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewUserModal.vue?vue&type=style&index=0&id=1445883a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1445883a",
  null
  
)

export default component.exports